import { styled } from '@mui/material/styles';
import { Box, Typography } from "@mui/material";
import successBadge from "../../assets/images/success-badge.svg";

const GlobalImg = styled('img')(({ theme: { breakpoints } }) => `
  margin: 20px auto;
  display: flex;
  ${[breakpoints.down('sm')]} {
    margin-top: 50px;
  }
`);

export const SetPasswordResetSuccess = ({ firstName }) => {
  const staticContent = {
    benefitCards: [],
    headline: 'Password reset successful',
    icon: successBadge,
    message: 'Your password has been reset successfully. Click below to return home and sign in with your updated credentials.',
  }

  return (
    <Box p={4}>
      <GlobalImg id="resetSucessImg" data-testid="resetSucessImg" alt='resetSucessImg' src={staticContent.icon} width="90" height="90"></GlobalImg>
      <Typography variant='h1' color={'primary.main'} mt={4} textAlign={'center'} id="resetSuccessText" data-testid="resetSuccessText" sx={{ margin: { sm: '32px 120px 0' }}}>{staticContent.message}</Typography>
    </Box>
  )
};